import * as React from "react";
import { cn } from "@/lib/utils";

export interface PageContentProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

const PageContent = React.forwardRef<HTMLDivElement, PageContentProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          "tw-flex tw-h-full tw-w-full tw-flex-col tw-overflow-auto",
          className
        )}
        {...props}
      >
        {children}
      </div>
    );
  }
);

PageContent.displayName = "PageContent";

const PageContentList = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, children, ...props }, ref) => {
  return (
    <div ref={ref} className={cn("tw-flex-1 tw-p-4", className)} {...props}>
      {children}
    </div>
  );
});

PageContentList.displayName = "PageContentList";

export { PageContent, PageContentList };
